<template>

<Sedes></Sedes>

</template>


<script>

import Sedes from '../../components/Sedes.vue';

export default {


 components:{

     Sedes

  }

}


</script>